var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('v-card',{staticClass:"elevation-0"},[_c('v-card-text',{staticClass:"pa-1"},[_c('bar-chart',{attrs:{"title":"Appointments by Time of Day","horizontal":true,"colors":_vm.colors,"data":_vm.chartData}})],1)],1):_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"card"}})
}
var staticRenderFns = []

export { render, staticRenderFns }